import { Dialog } from "react-native-paper";

import { events } from "@constants/tracking";
import useAnalytics from "@hooks/useAnalytics";
import DialogWrapper from "@memorang/ui/components/DialogWrapper";
import { useAppTheme } from "@memorang/ui/useAppTheme";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
/* ----------------- Components --------------- */
import DeleteForm from "../DeleteForm";

type Props = {
	visible: boolean;
	handleDismiss: () => void;
	handleSendFeedback: () => void;
};
const DeleteConfirmationDialog = ({
	visible,
	handleDismiss,
	handleSendFeedback,
}: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	const { explicitCallTrackCustomEvent } = useAnalytics();

	useEffect(() => {
		if (visible) {
			explicitCallTrackCustomEvent({
				eventName: events.dialogOpened,
				type: "delete_confirmation",
			});
		}
	}, [visible, explicitCallTrackCustomEvent]);

	const handleDialogClose = () => {
		handleDismiss();
		explicitCallTrackCustomEvent({
			eventName: events.dialogClosed,
			type: "delete_confirmation",
		});
	};
	return (
		<DialogWrapper
			visible={visible}
			maxWidth={"xs"}
			handleClose={handleDialogClose}
		>
			<Dialog.Icon color={theme.colors.error} icon="alert-outline" />
			<Dialog.Title
				style={{
					textAlign: "center",
				}}
			>
				{t("dialog.delete.confirmdelete.title")}
			</Dialog.Title>
			<Dialog.Content>
				<DeleteForm
					handleDismiss={handleDialogClose}
					handleSendFeedback={handleSendFeedback}
				/>
			</Dialog.Content>
		</DialogWrapper>
	);
};

export default DeleteConfirmationDialog;
